/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface ProductResponse
 */
export interface ProductResponse extends Status {
    /**
     * 
     * @type {Product}
     * @memberof ProductResponse
     */
    product?: Product;
}

/**
 * Check if a given object implements the ProductResponse interface.
 */
export function instanceOfProductResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductResponseFromJSON(json: any): ProductResponse {
    return ProductResponseFromJSONTyped(json, false);
}

export function ProductResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product']),
    };
}

export function ProductResponseToJSON(value?: ProductResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'product': ProductToJSON(value.product),
    };
}

